import { render, staticRenderFns } from "./add_st.vue?vue&type=template&id=12161342&"
import script from "./add_st.vue?vue&type=script&lang=js&"
export * from "./add_st.vue?vue&type=script&lang=js&"
import style0 from "./add_st.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports